/**
 * Utility function to convert Google Drive links & other image URLs 
 * into high-reliability proxied CDN streams.
 */
export const formatImageUrl = (url) => {
  if (!url) return '';
  if (Array.isArray(url)) url = url[0];
  if (typeof url !== 'string') return '';
  url = url.trim();

  const extractId = (link) => {
    const match1 = link.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
    if (match1) return match1[1];
    const match2 = link.match(/id=([a-zA-Z0-9_-]+)/);
    if (match2) return match2[1];
    const match3 = link.match(/\/d\/([a-zA-Z0-9_-]+)/);
    if (match3) return match3[1];
    return null;
  };

  if (url.includes('drive.google.com') || url.includes('googleusercontent.com')) {
    const id = extractId(url);
    if (id) {
      const driveUrl = `https://drive.google.com/thumbnail?id=${id}&sz=w1000`;
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
      return `${API_URL}/proxy/image?url=${encodeURIComponent(driveUrl)}`;
    }
  }

  return url;
};
